import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import {
  Box, Typography, Stack, TextField, InputAdornment, IconButton,
  CircularProgress, Alert, Paper, Table, TableContainer, TableHead,
  TableBody, TableRow, TableCell, Tooltip
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

import ModalEstado from "../componentes/modalestado";

export default function EstadoPage() {
  const [estados, setEstados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  const API_LISTAR_ESTADO = "https://demo.datachile.site/API/web/obtener_estados.php";
  const API_ELIMINAR_ESTADO = "https://demo.datachile.site/API/web/eliminar_estado.php";

  useEffect(() => {
    listarEstados();
  }, []);

  const listarEstados = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_LISTAR_ESTADO);

      // Verificar que sea un array
      const data = Array.isArray(res.data) ? res.data : [];
      setEstados(data);
    } catch (err) {
      console.error(err);
      setError("Error al cargar los estados");
      setEstados([]);
    } finally {
      setLoading(false);
    }
  };

  const eliminarEstado = async (idEstado) => {
    if (!window.confirm("¿Eliminar estado?")) return;

    try {
      const formData = new FormData();
      formData.append("idEstado", idEstado);

      await axios.post(API_ELIMINAR_ESTADO, formData);
      listarEstados();
    } catch (err) {
      console.error(err);
      setError("Error al eliminar estado");
    }
  };

  const filteredData = useMemo(() => {
    return estados.filter((e) =>
      e.estado.toLowerCase().includes(search.toLowerCase())
    );
  }, [estados, search]);

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems="center" spacing={2} sx={{ mb: 3 }}>
        <Box>
          <Typography variant="h4" fontWeight={700}>Estados</Typography>
          <Typography variant="body2" color="text.secondary">
            Administración y gestión de estados del sistema
          </Typography>
        </Box>

        <Stack direction="row" spacing={2}>
          <TextField
            size="small"
            placeholder="Buscar estado..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{ startAdornment: (<InputAdornment position="start"><SearchIcon /></InputAdornment>) }}
          />
          <ModalEstado actualizarTabla={listarEstados} />
        </Stack>
      </Stack>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}><CircularProgress /></Box>
      ) : (
        <TableContainer component={Paper} sx={{ borderRadius: 3, overflow: "hidden", boxShadow: "0 4px 20px rgba(0,0,0,0.05)" }}>
          <Table>
            <TableHead>
              <TableRow sx={{ background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>ID</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Estado</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center">No se encontraron estados</TableCell>
                </TableRow>
              ) : (
                filteredData.map((estado) => (
                  <TableRow key={estado.idEstado} sx={{ "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.08)" } }}>
                    <TableCell>{estado.idEstado}</TableCell>
                    <TableCell>{estado.estado}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Eliminar">
                          <IconButton color="error" onClick={() => eliminarEstado(estado.idEstado)}>
                            <DeleteForeverIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}